import { create } from 'zustand';
import { acionsTypesDashboard, Action, Dispatch } from '../../logic/actionsType';
import { IDashboard } from '../../../interfaces';


type TDashboardState = {
    dashboardValues?: IDashboard | undefined,
}

type State = {
    state: TDashboardState
}

const reducer = (state: State, action: Action<keyof typeof acionsTypesDashboard, TDashboardState>): State => {
    switch (action.type) {
        case 'SET_DASHBOARD_DEATIL_DATA':
            return { state: { ...state.state, dashboardValues: action.payload.dashboardValues } };
        default:
            return state;
    }
}

export const useDashboardStore = create<State & Dispatch<keyof typeof acionsTypesDashboard, TDashboardState>>((set) => ({
    state: {
        dashboardValues: undefined
    },
    dispatch: (action) => {
        set((state: State) => reducer(state, action));
    },
}));
